'use client';

import { useEffect, useState } from 'react';
import {
  getActiveBadgeData,
  updateLevelUpCarousalItems,
} from '@/components/level-up/level-up-carousel-data';
import { cn } from '@/lib/utils';
import DMTooltip from '../tooltip';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';
import LevelUpBadgeIcon from './level-up-badge-icon';

type Props = { point: number };
function LevelUpCarousel({ point }: Props) {
  const [showPoint, setShowPoint] = useState<boolean>(false);
  const [activeBadge, setActiveBadge] = useState<any>({});
  const [carouselData, setCarouselData] = useState<any>([]);
  const [activeBadgeIndex, setActiveBadgeIndex] = useState(0);
  // const currentPoint = point?.point

  useEffect(() => {
    getActiveBadgeDt();
  }, []);

  const getActiveBadgeDt = async () => {
    const data: any = await getActiveBadgeData(point || 0);
    setActiveBadge(data);
  };

  useEffect(() => {
    const carouselData = updateLevelUpCarousalItems(activeBadge?.id, activeBadge);
    setCarouselData(carouselData);
    const activeBadgeIndex = carouselData.findIndex(item => item.active === true);
    setActiveBadgeIndex(activeBadgeIndex);
  }, [activeBadge]);

  return (
    <>
      <Carousel
        className='relative w-full'
        opts={{
          startIndex: activeBadgeIndex,
        }}
      >
        <CarouselContent
          onMouseEnter={() => setShowPoint(true)}
          onMouseLeave={() => setShowPoint(false)}
          className='flex items-center w-52 md:w-full ml-16'
        >
          {carouselData &&
            carouselData?.map((item: any, index: number) => (
              <CarouselItem key={index} className='basis-44 md:basis-1/2 lg:basis-1/5 p-0 !m-0'>
                <div className={'flex items-center'}>
                  <div
                    className={cn(
                      'flex items-center flex-col mt-4',
                      !item.completed && !item.active ? 'grayscale-[50%] opacity-40' : ''
                    )}
                  >
                    <LevelUpBadgeIcon
                      showPoint={showPoint}
                      index={index}
                      currentPoint={point}
                      active={item.active}
                      icon={item.icon}
                      percentCompleted={item.percentCompleted}
                      progressColor={item.progressColor}
                    />

                    <p className={cn(item.textColor, item.active ? 'text-xs' : 'text-[10px]')}>
                      {item.name}
                    </p>
                  </div>
                  {index !== 6 && (
                    <div
                      className={cn(
                        'h-1 w-full bg-gray-600',
                        !item.completed && !item.active && 'grayscale-[50%] opacity-40',
                        index === 0 && 'rounded-l-lg'
                      )}
                    >
                      <div
                        className={cn(
                          'h-1 relative flex items-center',
                          item.progressColor,
                          index === 0 && 'rounded-l-lg'
                        )}
                        style={{
                          width: item?.percentCompleted !== 0 ? `${item.percentCompleted}%` : '0%',
                        }}
                      >
                        {item?.percentCompleted !== undefined && item.percentCompleted > 0 && (
                          <DMTooltip
                            open={showPoint}
                            triggerContent={
                              <span className='absolute flex h-3 w-3 right-0'>
                                <span
                                  className={cn(
                                    'animate-ping absolute inline-flex h-full w-full rounded-full opacity-75',
                                    item.progressColor
                                  )}
                                />
                                <span
                                  className={cn(
                                    'relative inline-flex rounded-full h-3 w-3',
                                    item.progressColor
                                  )}
                                />
                              </span>
                            }
                            tooltipContent={
                              <p className='text-black font-semibold text-xl flex flex-col items-center'>
                                {point} <span className='text-xs'>XP</span>
                              </p>
                            }
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </CarouselItem>
            ))}
        </CarouselContent>
      </Carousel>
    </>
  );
}

export default LevelUpCarousel;
